import { render } from "./TableBucketModal.vue?vue&type=template&id=320e365a&scoped=true"
import script from "./TableBucketModal.vue?vue&type=script&lang=js"
export * from "./TableBucketModal.vue?vue&type=script&lang=js"

import "./TableBucketModal.vue?vue&type=style&index=0&id=320e365a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Gerente de TI\\Downloads\\temp\\JB\\new-project\\jb-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320e365a"]])

export default __exports__